<div class="chimney-detail-modal">
  <div class="modal-header">
    <div class="title mx-auto col-12" id="modal-basic-title">
      {{ 'shift_' | lang }} {{ shift.name }}
    </div>
    <img appImageSelector alt="mt-image" imageType="icon" imageKey="close-gray" class="close-modal" (click)="activeModal.dismiss()">
    <div class="col-12 text-center modal-subtitle">{{ date }}</div>
  </div>

  <div class="modal-body">
    <app-main-table [tableConfig]="tableConfig" class="chimney-detail-table"></app-main-table>
  </div>
</div>